import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';

import Navbar from '../containers/Navbar';
import AuthNavbar from '../containers/AuthNavbar';
import Footer from './Footer';
import classes from '../../css/getCSS';


const layout = (props) => {
  let extraProps = {};
  if (props.background) {
    extraProps = {
      style: {
        backgroundImage: `url(${props.background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      },
    };
  }

  let navbar = <Navbar notLayoutView={props.notLayoutView}/>;

  if (props.isAuthenticated) {
    navbar = (
      <AuthNavbar
        activeLink={props.activeLink}
        dashActiveLink={props.dashActiveLink}
        onlyLogout={props.onlyLogout}
      />
    );
  }

  let footer = <Footer />

  if (props.notLayoutView){
    footer = null
  }

  return (
    <React.Fragment>
      { console.log('layout===props===',props) }
      <CssBaseline />
      <div className={[props.rootClass, classes.mainLayout].join(' ')} {...extraProps}>
        {navbar}
        <div className={classes.container}>
          {props.children}
        </div>
      </div>
      {footer}
    </React.Fragment>
  );
};

export default layout;



// WEBPACK FOOTER //
// ./src/common/components/MainLayout.js